import React, { useState } from "react";
import { useSelector } from "react-redux";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { useFormik } from "formik";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

export default function XuatUngVien(props) {
    const { user } = useSelector((state) => state.auth);

    const [linkDownload, setLinkDownLoad] = useState(null);
    const [dateSelect, setDateSelect] = useState({ datestart: null, dateend: null })

    const formik = useFormik({
        initialValues: { month: new Date().getMonth, year: new Date().getFullYear },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({

        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            let _url = URL_LIST_ALL + 'users_new?export=true&limit=10000000'
            if (values && values.part_id) _url = _url + '&part_id=' + values.part_id
            if (values && values.company_id) _url = _url + '&company_id=' + values.company_id
            if (values && values.datestart) _url = _url + '&datestart=' + values.datestart
            if (values && values.dateend) _url = _url + '&dateend=' + values.dateend
            Axios.get(_url, user.config).then(async (res) => {
                console.log(res)
                setSubmitting(false);
                if (res.data.status === "success") {
                    resetForm();
                    // window.open(res.data.data, "_blank")
                    setLinkDownLoad(res.data.data)
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch((err) => console.log(err));
        },
    });

    const handleDate = (name, value) => {
        formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
        formik.setFieldTouched(name)
        let newDate = Object.assign({}, dateSelect)
        newDate[name] = value
        setDateSelect(newDate)
    };

    return (
        <AkkhorLayout idrole="users_new" >
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/users_new">Danh sách ứng viên</Link>
                    </li>
                    <li>Xuất danh sách ứng viên</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Xuất danh sách ứng viên</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-sm-4 col-12 form-group">
                                <label>Từ ngày: <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('datestart', value) }} value={dateSelect.datestart ? new Date(dateSelect.datestart) : null} format="dd-MM-y" className="form-control height32 air-datepicker" disableClock={true}
                                    hourPlaceholder="giờ" minutePlaceholder="phút" secondPlaceholder="giây" yearPlaceholder="Năm" monthPlaceholder="Tháng" dayPlaceholder="Ngày" maxDate={new Date()}></DateTimePicker>

                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Tới ngày: <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('dateend', value) }} value={dateSelect.dateend ? new Date(dateSelect.dateend) : ''} format="dd-MM-y" className="form-control height32 air-datepicker" disableClock={true}
                                    hourPlaceholder="giờ" minutePlaceholder="phút" secondPlaceholder="giây" yearPlaceholder="Năm" monthPlaceholder="Tháng" dayPlaceholder="Ngày" minDate={dateSelect.datestart ? new Date(dateSelect.datestart) : new Date()} maxDate={new Date()}></DateTimePicker>

                            </div>
                            <div className="col-12 mg-t-8">
                                <div className="col-12"></div>
                                {linkDownload && (
                                    <div className="my-3">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                fetch(linkDownload)
                                                    .then((res) => res.blob())
                                                    .then((blob) => {
                                                        let url = window.URL.createObjectURL(blob);
                                                        url = url.replace(/^http:\/\//i, 'https://');
                                                        const a = document.createElement('a');
                                                        a.href = url;
                                                        a.download = 'danh_sach_ung_vien.xlsx';
                                                        document.body.appendChild(a);
                                                        a.click();
                                                        a.remove();
                                                        window.URL.revokeObjectURL(url);
                                                    })
                                                    .catch((e) => {
                                                        console.log(e);

                                                        alert("Không thể tải file. Vui lòng thử lại.");
                                                    });
                                            }}
                                        >
                                            Tải file Excel
                                        </button>
                                    </div>
                                )}
                                <div className="alert alert-primary" role="alert">
                                    <div className="mt-3">
                                        <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark mr-2">{formik.isSubmitting ? <Spinner /> : <>Xuất File</>}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
